export class DatetimeHelper {
    static formatDateFromString(dateAsYYYMMDD) {
        if(!dateAsYYYMMDD)
            return null;

        const year = parseInt(dateAsYYYMMDD.substring(0, 4), 10);
        const month = parseInt(dateAsYYYMMDD.substring(4, 6), 10) - 1;  // Months are 0-based in JS
        const day = parseInt(dateAsYYYMMDD.substring(6, 8), 10);

        return new Date(year, month, day);
    }

    static YYYYMMDDToFriendlyStr(yyyymmdd) {
        yyyymmdd = yyyymmdd.replaceAll("-", "");
        if (!/^(\d{4})(\d{2})(\d{2})$/.test(yyyymmdd)) {
            throw new Error("Invalid date format. Expected 'yyyymmdd'.");
        }

        const year = yyyymmdd.substring(0, 4);
        const month = yyyymmdd.substring(4, 6);
        const day = yyyymmdd.substring(6, 8);

        return `${day}/${month}/${year}`;
    }

    static DateToFriendlyStr(aDate) {
        const year = aDate.getFullYear();
        const month = aDate.getMonth() + 1;
        const day = aDate.getDate();

        return `${day}/${month}/${year}`;
    }

    static friendlyDDMMYYYYToYYYYMMDD(friendlyDDMMYYYY, separator="") {
        friendlyDDMMYYYY = friendlyDDMMYYYY.replaceAll("/", "");
        if (!/^(\d{2})(\d{2})(\d{4})$/.test(friendlyDDMMYYYY)) {
            throw new Error("Invalid date format. Expected 'yyyymmdd'.");
        }

        const day = friendlyDDMMYYYY.substring(0, 2);
        const month = friendlyDDMMYYYY.substring(2, 4);
        const year = friendlyDDMMYYYY.substring(4, 8);

        return `${year}${separator}${month}${separator}${day}`;
    }

    static friendlyDDMMYYYYToDate(friendlyDDMMYYYY, separator="") {
        friendlyDDMMYYYY = friendlyDDMMYYYY.replaceAll("/", "");
        if (!/^(\d{2})(\d{2})(\d{4})$/.test(friendlyDDMMYYYY)) {
            throw new Error("Invalid date format. Expected 'yyyymmdd'.");
        }

        const day = friendlyDDMMYYYY.substring(0, 2);
        const month = friendlyDDMMYYYY.substring(2, 4);
        const year = friendlyDDMMYYYY.substring(4, 8);

        return new Date(year, month-1, day);
    }

    static YYYYMMDDToDay(yyyymmdd) {
        if (!/^(\d{4})(\d{2})(\d{2})$/.test(yyyymmdd)) {
            throw new Error("Invalid date format. Expected 'yyyymmdd'.");
        }

        const day = yyyymmdd.substring(6, 8);

        return `${day}`;
    }


    /**
     * ESTO NO FUNCIONA. LE CAMBIA EL VALOR A -03:00 entonces se va al dia anterior
     *
     * Converts a date string in the format YYYYMMDD to a JavaScript Date object.
     * @param {string} yyymmdd - The date string in YYYYMMDD format.
     * @param {string} [separator='-'] - The separator to use in the parsed date string, default is '-'.
     * @returns {Date | null} - A JavaScript Date object or null if the input is invalid.
     */
    static fromYYYYMMDDToDate(yyymmdd, separator = '-') {
        if (!yyymmdd){
            console.error('Invalid YYYYMMDD string provided:', yyymmdd);
            return null;
        }

        if(separator) {
            yyymmdd = yyymmdd.replaceAll(separator,"");
        }

        if(yyymmdd.length !== 8 || isNaN(Number(yyymmdd))) {
            console.error('Invalid YYYYMMDD string provided:', yyymmdd);
            return null;
        }

        try {
            const year = yyymmdd.slice(0, 4);
            const month = yyymmdd.slice(4, 6); // Month is 1-based in the string but 0-based in Date.
            const day = yyymmdd.slice(6, 8);

            const date = new Date(year, month-1, day);
            date.setUTCHours(0, 0, 0, 0); // Ensure no time adjustments.
            return date;
        } catch (error) {
            console.error('Error parsing YYYYMMDD string to Date:', error);
            return null;
        }
    }

    static formatDateToYYYYMMDD(date, separator="") {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero
        const day = String(date.getDate()).padStart(2, '0'); // Add leading zero
        return `${year}${separator}${month}${separator}${day}`;
    };


    static calculateDatesForMonthlyPeriod(aDayNumber){
        if (aDayNumber < 1 || aDayNumber > 31) {
            throw new Error('aDayNumber must be between 1 and 31');
        }

        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // 0-based index for months

        // First date: aDayNumber/ThisMonth/ThisYear
        const firstDate = new Date(year, month, aDayNumber);

        // Last date: day before aDayNumber/NextMonth/ThisYear
        const nextMonth = new Date(year, month + 1, 1); // 1st day of next month
        const lastDate = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), aDayNumber - 1);

        return { firstDate, lastDate };
    };

    static isoToFriendlyDateTime(isoString) {
        if (!isoString) {
            return "Nunca";
        }

        const date = new Date(isoString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
}